import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="navigations--sidebar"
export default class extends Controller {
  static values = { sidebarOpen: { type: Boolean, default: false } };
  static targets = ["backdrop", "button", "container", "menu"];

  open() {
    this.sidebarOpenValue = true;
  }

  close() {
    this.sidebarOpenValue = false;
  }

  sidebarOpenValueChanged() {
    if (this.sidebarOpenValue) {
      this.containerTarget.classList.remove("hidden");
      enter(this.backdropTarget);
      enter(this.menuTarget);
      enter(this.buttonTarget);
    } else {
      Promise.all([
        leave(this.backdropTarget),
        leave(this.menuTarget),
        leave(this.buttonTarget),
      ]).then(() => {
        this.containerTarget.classList.add("hidden");
      });
    }
  }
}
